import React from 'react';
import { ModalForm, AfterSubmitProps, FormFieldsData } from 'framework/form';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { ComplianceDocumentTypeFE } from 'domain/shared/compliance';
import ViewComplianceDocumentContent from './ViewComplianceDocumentContent';
import { useShowContext } from 'framework/show';

const ViewComplianceDocumentAction = ({
  modalOpen,
  closeModal,
  afterSubmit,
}: {
  modalOpen: boolean;
  closeModal: () => void;
  afterSubmit: AfterSubmitProps<(response: FormFieldsData) => void>;
}) => {
  const { data } = useShowContext<ComplianceDocumentTypeFE>();
  const { editDocument, getValidationSchema } = useDocumentStorageContext();

  const documentData = data.getData();

  const initialData = {
    ...documentData.metadata,
    paths: [documentData.path],
  };

  return (
    <ModalForm
      getValidationSchemaFunc={getValidationSchema}
      modalOpen={modalOpen}
      closeModal={closeModal}
      handleDirty
      submitFormFunc={editDocument}
      afterSubmit={{
        ...afterSubmit,
      }}
      initialData={initialData}
      isHideDefaultButtons
    >
      <ViewComplianceDocumentContent />
    </ModalForm>
  );
};

export default ViewComplianceDocumentAction;
